'use client'

import React, { useEffect, useState } from 'react'
import { Message } from '@locmod/intl'
import cx from 'classnames'

import Betslip from 'compositions/Betslip/Betslip'
import AcceptedBets from 'compositions/AcceptedBets/AcceptedBets'

import messages from './messages'
import { useSearchParams } from 'next/navigation'
import decompressData from 'src/utils/decompressData'

import { useBaseBetslip } from '@azuro-org/sdk'
import { openModal } from '@locmod/modal'

const tabs = ['betslip', 'myBets'] as const

const TabbedBetslip: React.FC = () => {
  const [activeTab, setActiveTab] = useState<(typeof tabs)[number]>('betslip')
  const searchParams = useSearchParams()
  const { addItem, clear } = useBaseBetslip()
  useEffect(() => {
    const data = searchParams.get('data')
    if (data) {
      sessionStorage.setItem('data', data)

      // Clean up URL without page reload
      window.history.replaceState({}, '', '/')
    }
  }, [searchParams])

  // Second useEffect: Process data from sessionStorage when at root URL
  useEffect(() => {
    const processStoredData = async () => {
      const data = sessionStorage.getItem('data')
      if (data) {
        try {
          const decompressedData = decompressData(data)
          setTimeout(() => {
            // Clear existing betslip
            clear()
            setTimeout(async () => {
              if (Array.isArray(decompressedData)) {
                for (const item of decompressedData) {
                  addItem({
                    conditionId: item.conditionId,
                    outcomeId: item.outcomeId,
                    isExpressForbidden: item.isExpressForbidden,
                    marketName: item.marketName,
                    game: item.game,
                    selectionName: item.selectionName,
                    gameId: item.game.gameId,
                  })
                  await new Promise(resolve => setTimeout(resolve, 500))
                }
              } else {
                addItem({
                  conditionId: decompressedData.conditionId,
                  outcomeId: decompressedData.outcomeId,
                  isExpressForbidden: decompressedData.isExpressForbidden,
                  marketName: decompressedData.marketName,
                  game: decompressedData.game,
                  selectionName: decompressedData.selectionName,
                  gameId: decompressedData.game.gameId,
                })
                await new Promise(resolve => setTimeout(resolve, 500))
              }

              // Clean up sessionStorage after processing
              sessionStorage.removeItem('data')

              // Ensure betslip tab is active
              setActiveTab('betslip')
              const betslipItems =
                localStorage.getItem('betslipItems-v3') || '[]'
              if (betslipItems === '[]') {
                openModal('ErrorModal', {
                  title: 'Copybet Error',
                  text: 'Failed to copy the bet.',
                })
              }
            }, 3000)
          }, 0)
        } catch (error) {
          console.error('Error processing stored data:', error)
          sessionStorage.removeItem('data')
        }
      }
    }

    processStoredData()
  }, [addItem, clear]) // Only run once when component mounts and when betslip functions are available

  return (
    <>
      <div className="bg-bg-l0 rounded-md border border-grey-15 p-1 flex items-center">
        {tabs.map(tab => {
          const isActive = activeTab === tab

          return (
            <button
              key={tab}
              className={cx('w-full p-2 text-center rounded-sm', {
                'text-grey-60 hover:text-grey-90': !isActive,
                'text-grey-90 bg-grey-10': isActive,
              })}
              onClick={() => setActiveTab(tab)}
            >
              <Message value={messages[tab]} />
            </button>
          )
        })}
      </div>
      {activeTab === 'betslip' && <Betslip />}
      {activeTab === 'myBets' && <AcceptedBets />}
    </>
  )
}

export default TabbedBetslip
